(function () {
	if (window.__storeAvailabilityLoaded) return;
	window.__storeAvailabilityLoaded = true;

	var PROXY_URL = '/apps/store-availability';
	var CACHE = Object.create(null);

	function hideContainer(container) {
		if (!container) return;
		container.innerHTML = '';
		container.style.display = 'none';
	}

	function showContainer(container) {
		if (!container) return;
		container.style.display = '';
	}

	function render(container, data) {
		if (!container) return;
		var variantAvailable = container.dataset.variantAvailable === 'true';
		var locations = (data && data.locations) || [];
		var inStock = locations.filter(function (l) { return l.in_stock; });

		if (!variantAvailable) {
			hideContainer(container);
			return;
		}

		showContainer(container);

		var count = inStock.length;
		var statusText;
		if (count === 0) {
			statusText = 'E disponueshme online';
		} else if (count === 1) {
			statusText = 'E disponueshme online dhe ne 1 dyqan Lifestyle';
		} else {
			statusText = 'E disponueshme online dhe ne ' + count + ' dyqane Lifestyle';
		}

		var statusHtml =
			'<p class="product-store-availability__status product-store-availability__status--available">' +
			'<span class="product-store-availability__dot product-store-availability__dot--in"></span>' +
			statusText +
			'</p>';

		var listHtml = '';
		if (count > 0) {
			var list = inStock
				.map(function (loc) {
					return '<li>' + escapeHtml(loc.name) + '</li>';
				})
				.join('');
			listHtml = '<ul class="product-store-availability__locations">' + list + '</ul>';
		}

		container.innerHTML = statusHtml + listHtml;
	}

	function renderError(container) {
		hideContainer(container);
	}

	function escapeHtml(str) {
		return String(str == null ? '' : str)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}

	function fetchAvailability(variantId) {
		if (CACHE[variantId]) return CACHE[variantId];
		var promise = fetch(PROXY_URL + '?variant_id=' + encodeURIComponent(variantId), {
			headers: { Accept: 'application/json' },
			credentials: 'same-origin',
		})
			.then(function (res) {
				if (!res.ok) throw new Error('HTTP ' + res.status);
				return res.json();
			})
			.catch(function (err) {
				delete CACHE[variantId];
				throw err;
			});
		CACHE[variantId] = promise;
		return promise;
	}

	function loadFor(container) {
		if (!container) return;
		var variantId = container.dataset.variantId;
		if (!variantId) {
			renderError(container);
			return;
		}
		fetchAvailability(variantId)
			.then(function (data) {
				console.groupCollapsed(
					'%c[StoreAvailability] variant ' + variantId,
					'color:#2e8b57;font-weight:bold;'
				);
				console.log(data);
				console.groupEnd();
				render(container, data);
			})
			.catch(function (err) {
				console.error('[StoreAvailability] fetch failed for variant', variantId, err);
				renderError(container);
			});
	}

	function init() {
		var containers = document.querySelectorAll('[id^="StoreAvailability-"]');
		containers.forEach(loadFor);
	}

	window.refreshStoreAvailability = function (element) {
		if (!element) return;
		loadFor(element);
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
